import { Typography } from "@mui/material";
import { useRef, useCallback, useState, useEffect } from "react";
import { CONTACT_MANAGEMENT_URL } from "../../../utils/properties";
import "./contactManager.css";
import { checkSettings } from "../../../utils/util";

function ContactManager() {
    const [subUserAgentMapping, setSubUserAgentMapping] = useState<boolean>(false);
    const iframeRef = useRef<HTMLIFrameElement>(null);

    const token = localStorage.getItem('token');
    const url = new URL(CONTACT_MANAGEMENT_URL);
    try {
        url.searchParams.append('UserAgentMapping', 'true');
        if (token) {
            url.searchParams.append('token', token);
        }
    } catch (error) {
        console.log('error in ContactManager', error);
    }

    async function isSubUserAgentMapping() {
        try {
            const resp = await checkSettings("USER_AGENT_MAPPING")
            if (resp && (resp === true || resp === "true")) {
                setSubUserAgentMapping(true)
            }
        } catch (error) {
            setSubUserAgentMapping(false)
            console.log("error in isSubUserAgentMapping", error)
        }
    }

    useEffect(() => {
        isSubUserAgentMapping()
    }, [])

    const handleIframeLoad = useCallback(() => {
        try {
            if (iframeRef.current && iframeRef.current.contentWindow) {
                const payload = {
                    action: "login-cm-icici",
                    data: {
                        token: token || '',
                        UserAgentMapping: true
                    }
                };

                try {
                    iframeRef.current.contentWindow.postMessage(payload, url.origin);
                    console.log('PostMessage sent to ContactManager iframe:', payload);
                } catch (error) {
                    console.error('Error sending postMessage to ContactManager iframe:', error);
                }
            }
        } catch (error) {
            console.log('error in handleIframeLoad ContactManager', error);
        }
    }, [token, url.origin]);

    return subUserAgentMapping ?
        (
            <div className="ozAppsContactManagerContainer">
                <Typography sx={{ fontSize: "0.75rem", lineHeight: "0.875rem", marginBottom: "0.625rem", color: "#212121", }}>
                    Apps
                </Typography>
                <Typography sx={{ fontStyle: "normal", fontWeight: 600, fontSize: "1.5rem", lineHeight: "1.75rem", mb: 1 }}>
                    Contact Manager
                </Typography>
                <div className="oz-contact-manager-iframe-container">
                    <iframe
                        ref={iframeRef}
                        sandbox="allow-scripts allow-forms allow-same-origin allow-popups allow-modals allow-downloads"
                        allow="geolocation; microphone; camera;display-capture"
                        src={url.toString()}
                        title="Contact Manager"
                        className="oz-contact-manager-iframe"
                        onLoad={handleIframeLoad}
                    />
                </div>
            </div>
        ) : (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 100px)' }}>
                <Typography>
                    You are not authorized to access this page
                </Typography>
            </div>
        )
}

export default ContactManager; 